import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import FsLightbox from "fslightbox-react";

const Hero = () => {
  const [toggler, setToggler] = useState(false);
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { t } = useTranslation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setMessage('');

    // Prepare data for Web3Forms
    const data = {
      access_key: "6524626a-b495-4e3c-bc7f-24a187d51cca",
      email: email,
      subject: "Newsletter Subscription Request",
      message: `New newsletter subscription request from: ${email}`
    };

    try {
      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data)
      });

      const result = await response.json();

      if (result.success) {
        setMessage(t('sections.heroOne.subscribe_success','✅ Thank you for subscribing! We will be in touch soon.'));
        setEmail('');
      } else {
        setMessage(t('sections.heroOne.subscribe_failed','❌ Failed to subscribe. Please try again.'));
      }
    } catch (error) {
      setMessage(t('sections.heroOne.subscribe_error','❌ An error occurred. Please try again later.'));
      console.error('Newsletter subscription error:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="ot-hero-wrapper hero-1" id="hero" data-bg-src="assets/img/hero/hero-bg1-1.png">
      <div className="bg-gradient-shape1"></div>
      <div className="bg-gradient-shape2"></div>
      <div className="hero-shadow-text" data-cue="slideInUp" data-delay="100">
        <span className="shadow-text">{t('sections.heroOne.shadow','SECURE')}</span>
      </div>
      <div className="hero-inner">
        <div className="container">
          <div className="row gy-40 align-items-center flex-row-reverse">
            <div className="col-xl-6">
              <div className="hero-thumb1-1" data-cue="slideInUp" data-delay="200">
                <img src="assets/img/hero/hero-thumb1-1.png" alt="img" />
              </div>
            </div>
            <div className="col-xl-6">
              <div className="hero-style1">
                <h1 className="hero-title">
                  <span className="title1" data-cue="slideInUp" data-delay="100"><span className="text-theme">{t('sections.heroOne.title_theme','25 Years of')}</span> {t('sections.heroOne.title_main','Cyber')}</span>
                  <span className="title2" data-cue="slideInUp" data-delay="200">{t('sections.heroOne.title_sub','Security Expertise')}</span>
                </h1>
                <p className="hero-text" data-cue="slideInUp" data-delay="300">{t('sections.heroOne.text','Safeguard your business from cyber threats with Secur\'s advanced cybersecurity solutions. Our comprehensive suite of services includes threat detection and response, vulnerability assessment and penetration testing, incident response.')}</p>
                <div className="newsletter-form" data-cue="slideInUp" data-delay="400">
                  <form onSubmit={handleSubmit}>
                    <div className="form-group">
                      <input 
                        className="form-control" 
                        type="email" 
                        placeholder={t('sections.heroOne.placeholder_email','Enter Your Email')}
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        disabled={isSubmitting}
                      />
                    </div>
                    <button 
                      type="submit" 
                      className="ot-btn"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? t('sections.heroOne.sending','Sending...') : t('sections.heroOne.get_consultation','Get a Free Consultation')} 
                      <i className="far fa-long-arrow-right ms-2"></i>
                    </button>
                  </form>
                  {message && (
                    <p style={{ 
                      marginTop: '15px',
                      color: message.includes('✅') ? '#069845' : '#dc3545',
                      fontWeight: '500',
                      fontSize: '14px'
                    }}>
                      {message}
                    </p>
                  )}
                </div>
                <div className="btn-wrap" data-cue="slideInUp" data-delay="200">
                  <div className="video-arrow">
                    <svg width="92" height="142" viewBox="0 0 92 142" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M61.1645 140.699L62.1362 140.829C62.5635 141.351 62.8467 141.488 63.432 141.799C68.8936 141.272 86.3616 138.408 90.4876 136.493C91.3985 136.071 91.734 135.511 91.885 134.509C92.0196 133.617 91.5408 132.657 91.0254 131.964C89.0026 129.238 80.561 121.417 77.7424 119.604C76.3802 118.728 75.183 118.286 73.5988 117.999L73.188 118.488C74.1371 121.788 80.5268 127.613 82.8804 130.597C76.7475 129.171 70.5013 128.275 64.3644 126.854C47.3536 122.919 32.5762 115.083 21.9189 101.006C6.00494 79.985 2.30306 51.2908 5.90317 25.859C7.42091 16.2234 10.0813 9.64205 12.7086 0.588001L12.4475 0.687956C6.89623 10.7105 3.69211 21.2114 2.05513 32.529C-1.46137 56.8418 3.16169 85.0555 18.1619 104.968C34.1354 126.174 54.2713 130.83 79.1275 134.296C73.4445 135.301 66.0155 137.552 61.1645 140.699Z" fill="currentColor" />
                    </svg>
                  </div>
                    <a 
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        setToggler(!toggler);
                      }}
                      className="play-btn"
                    >
                      <i className="fas fa-play"></i>
                    </a>
                    
                    <FsLightbox
                      toggler={toggler}
                      sources={[
                        "https://www.youtube.com/watch?v=Z4F3AXvrLKo"
                      ]}
                    />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;